





























































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { getCurrency } from '@/utils/commonUtils';

@Component
export default class ComponentProductExchangeDetails extends Vue { //G
  @Watch('postPredict')
  onPredictChange(){
    this.postPredictCalculation();
  }

  @Prop({required: true})
  private pageName!: string ;
  
  @Prop({required: true})
  private postPredict!: {};

  @Prop({required: true})
  private objJson!: string;
  
  @Prop({ required: true })
  private readonly freeGiftDiscountAmt: number;


  private showWhoDoesPay: boolean = false

  private cancelTotalPrice: number = 0;
  private exchangeTotalPrice: number = 0;
  private exchangeCancelTotalPrice: number = 0;
  private exchangeAddTotalPrice: number = 0;
  private cancelAddTotalPrice: number = 0;
  private exchangeAddCancelAddTotalPrice: number = 0;
  private productCouponDiscountAmt: number = 0;
  private exchangeProductAmtAdjustAmt: number = 0;
  private exchangeProductAmtAdjustReason: string = '';
  private totalPayAmt: number = 0;
  private orgTotalPayAmt: number = 0;
  private totalDeliveryAmt: number = 0;
  private totalExchangeAmt: number = 0;
  private displayedDeliveryAmtDiscountMessage:boolean = false;

  private created(){
    this.postPredictCalculation();
    this.defaultCalculation();
  }
  private defaultCalculation() {
    this.cancelTotalPrice = 0;
    this.exchangeTotalPrice = 0;
    this.cancelAddTotalPrice = 0;
    this.exchangeAddCancelAddTotalPrice = 0;
    this.orgTotalPayAmt = 0;
    this.totalExchangeAmt = 0;
    this.totalPayAmt = 0;
  }
  private onExchangeChange(){
    if(this.exchangeProductAmtAdjustAmt > this.orgTotalPayAmt) {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER5'));
      this.exchangeProductAmtAdjustAmt = 0
      this.exchangeProductAmtAdjustReason = ''
    }
    if(!this.exchangeProductAmtAdjustAmt) {
      this.exchangeProductAmtAdjustAmt = 0
      this.exchangeProductAmtAdjustReason = ''
    }
    let refundOrderPrice = (this.postPredict as any).amounts.refund.order;
    let totalRefundOrderPrice = refundOrderPrice.exchangeTotalPrice - refundOrderPrice.cancelTotalPrice + refundOrderPrice.additionalDiscountAmt

    if(totalRefundOrderPrice < this.exchangeProductAmtAdjustAmt) {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER5'));
      this.exchangeProductAmtAdjustAmt = 0
      return this.onExchangeChange();
    } else {
      if (this.pageName==='ExchangePopupBefore' || this.pageName==='ExchangePopupAfter') {
        this.showWhoDoesPay = Number(this.exchangeProductAmtAdjustAmt) > 0
        this.$emit('setData');
      }
    }
  }

  private showCancelProductCoupons(cancelProductCoupons: any){
    let strReturn = '';
    if (cancelProductCoupons==null || cancelProductCoupons.productCoupons==null){
      return this.$t('CLAIM_CANCELPOPUP_NO_COUPON_APPLIED');
    }
    let temp: any[] = cancelProductCoupons.productCoupons
    temp.forEach((item) =>{
      strReturn = strReturn + item.couponNo + ' ' + item.couponName + ', '
    });
    if (strReturn==''){
      return this.$t('CLAIM_CANCELPOPUP_NO_COUPON_APPLIED');
    } else {
      return this.$t('CLAIM_CANCELPOPUP_COUPON_NUMBER') + strReturn.substring(0,strReturn.length-2)+')';
    }
  }
  
  private postPredictCalculation() {
    this.cancelTotalPrice = (this.$parent.$refs.componentItemsClaim as any).claimableOptions[0].totalProductPriceOrderCnt;
    this.exchangeTotalPrice = this.cancelTotalPrice - ((this.postPredict as any).amounts.refund.order.standardAmt - (this.postPredict as any).amounts.refund.order.immediateDiscountAmt - (this.postPredict as any).amounts.productAdjustAmt);
    this.exchangeCancelTotalPrice = this.exchangeTotalPrice - this.cancelTotalPrice;
    this.exchangeAddTotalPrice = (this.$parent.$refs.componentProductExchange as any).optionAddPrice * (this.$parent.$refs.componentProductExchange as any).exchangeCnt;
    this.cancelAddTotalPrice = (this.$parent.$refs.componentItemsClaim as any).claimableOptions[0].additionalDiscountAmt * (this.$parent.$refs.componentItemsClaim as any).orderCntArry[0];
    this.exchangeAddCancelAddTotalPrice = this.exchangeAddTotalPrice - this.cancelAddTotalPrice;
    this.productCouponDiscountAmt = (this.postPredict as any).amounts.refund.coupon.productCouponDiscountAmt * -1;
    this.totalPayAmt = this.exchangeCancelTotalPrice - this.exchangeAddCancelAddTotalPrice - this.productCouponDiscountAmt - this.exchangeProductAmtAdjustAmt - this.freeGiftDiscountAmt;
    this.orgTotalPayAmt = this.exchangeCancelTotalPrice - this.exchangeAddCancelAddTotalPrice - this.productCouponDiscountAmt;
    this.totalDeliveryAmt = (this.postPredict as any).amounts.refund.coupon.cartCouponDiscountAmt - (this.postPredict as any).amounts.refund.delivery.totalDeliveryAmt;
    this.totalExchangeAmt = this.totalPayAmt - this.totalDeliveryAmt;
    this.displayedDeliveryAmtDiscountMessage = (this.postPredict as any).amounts.before.delivery.deliveryGroupAmounts.alreadyPaidTotalDeliveryAmt !== (this.postPredict as any).amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt;
  }

  protected onlyCommaNumber(event: Event) {
    const $input = event.target as HTMLInputElement;

    if ($input.value === '' || $input.value === '0') {
      $input.value = '0';
      return;
    }

    $input.value = $input.value
        .toString()
        .replace(/\D/g, '')
        .replace(/^0+/, '')
        // .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  
  private getCurrency(money: number): string {
    return this.postPredict ? getCurrency(money) : '';
  }
}
